/* eslint-disable */
import Vue from 'vue';
import ProjectBasicSettingsForm from '@shared/modules/project-settings/project-basic-settings-form';
import PopupWrapper from '@shared/shared-components/shared/popup-wrapper';
import ProjectBranchSelector from '@shared/shared-components/shared/project-branch-selector';
import PreMergeRequestForm from '@shared/shared-components/pre-merge-request/pre-merge-request-form';
import CommitDiffList from '@shared/shared-components/commit-diff/commit-diff-list';
import RepositoryFilesList from '@shared/shared-components/shared/repository-files-list';
import CustomSelectorDotOption from '@shared/shared-components/shared/custom-selector-dot-option';
import forkInformation from '@shared/shared-components/fork-information';
import reportForm from '@shared/shared-components/report-form';
import ProjectLanguageSelector from '@shared/shared-components/shared/project-language-selector';
import GfQrCodeGenerator from '@shared/shared-components/shared/GfQrCodeGenerator';
import GfCustomClipboard from '@shared/shared-components/shared/GfCustomClipboard';
import ProjectMemberSelector from '@shared/shared-components/shared/project-member-selector';
import ProjectOwnerSelector from '@shared/shared-components/shared/project-owner-selector';
import ProjectTagSelector from '@shared/shared-components/shared/project-tag-selector';
import ProjectTopicSelector from '@shared/shared-components/shared/project-topic-selector';
import GfDropdown from '@shared/shared-components/shared/GfDropdown';
import GfCustomTabs from '@shared/shared-components/shared/GfCustomTabs';
import GfCustomModalWindow from '@shared/shared-components/shared/GfCustomModalWindow';
import GfCustomTooltip from '@shared/shared-components/shared/GfCustomTooltip';
import GfUserAvatarCropper from '@shared/shared-components/shared/GfUserAvatarCropper';
import GfTeamAvatarCropper from '@shared/shared-components/shared/GfTeamAvatarCropper';
import GfCompanyAvatarCropper from '@shared/shared-components/shared/GfCompanyAvatarCropper';
import GfUserCoverCropper from '@shared/shared-components/shared/GfUserCoverCropper';
import GfCloudwebProjectTabsEdit from '@shared/shared-components/shared/GfCloudwebProjectTabsEdit';
import GfCustomCollapse from '@shared/shared-components/shared/GfCustomCollapse';
import GfCustomAlert from '@shared/shared-components/shared/GfCustomAlert';
import GfCustomTextEditor from '@shared/shared-components/shared/GfCustomTextEditor';
import GfCopyCommitHash from '@shared/shared-components/shared/GfCopyCommitHash';
import GfCustomMultiFileUploader from '@shared/shared-components/shared/GfCustomMultiFileUploader';
import GfRegistryCategorySelector from './shared-modules/shared-components/shared/GfRegistryCategorySelector';
import tagReleaseSortTypeSelector from '@shared/shared-components/shared/tag-release-sort-type-selector';
import tagReleaseSortDirectionSelector from '@shared/shared-components/shared/tag-release-sort-direction-selector';
import GfCustomFileUploader from '@shared/shared-components/shared/GfCustomFileUploader';
import GfCompanyCoverCropper from '@shared/shared-components/shared/GfCompanyCoverCropper';
import PyPiForm from '@/shared-modules/modules/registry/components/PyPiUploadFilesForm';
import GfAddFilesDropdown from '@shared/shared-components/file-blob/GfAddFilesDropdown';
import GfCloneProjectDropdown from '@shared/shared-components/shared/GfCloneProjectDropdown';
import ProjectCiCdSettingsForm from '@shared/modules/project-settings/project-ci-cd-settings-form';
import GfCustomInputNumber from '@shared/shared-components/shared/GfCustomInputNumber.vue';
import RegistryKeySelector from '@/shared-modules/modules/registry/components/RegistryKeySelector';
import GfDropdownCiCd from '@shared/shared-components/shared/GfDropdownCiCd';
import ProjectFilterForm from '@/shared-modules/modules/project/components/project-filter-form';
import ProjectSettingsWebhookUrl from '@shared/modules/project-settings/project-setting-webhook-url';
import GfProjectCardStatic from '@/shared-modules/shared-components/shared/GfProjectCardStatic';
import GfSettingsProjectCardStatic from '@/shared-modules/shared-components/shared/GfSettingsProjectCardStatic';
import GfListGridControllerStatic from '@/shared-modules/shared-components/shared/GfListGridControllerStatic';
import GfCompanyCardStatic from '@/shared-modules/shared-components/shared/GfCompanyCardStatic';
import GfUserCardStatic from '@/shared-modules/shared-components/shared/GfUserCardStatic';
import ProfileLayout from '@/shared-modules/modules/profile/pages/profile-layout';
import GfButtonSubscribeUser from '@/shared-modules/modules/profile/components/GfButtonSubscribeUser';
import GfButtonShare from '@shared/shared-components/shared/components/GfButtonShare';
import GfButton from '@shared/shared-components/shared/components/GfButton';
import GfLinkButton from '@shared/shared-components/shared/components/GfLinkButton';
import GfUserFollowersCounter from '@shared/modules/profile/components/GfUserFollowersCounter';
import GfTeamCardStatic from '@/shared-modules/shared-components/shared/GfTeamCardStatic';
import GfButtonProjectSubscribe from '@shared/modules/project/components/GfButtonProjectSubscribe';
import GfButtonTeamSubscribe from '@shared/modules/team/components/GfButtonTeamSubscribe';
import GfButtonCompanySubscribe from '@shared/modules/company/components/GfButtonCompanySubscribe';
import GfPackageCardStatic from '@/shared-modules/shared-components/shared/GfPackageCardStatic';
import TeamVariableTable from '@shared/modules/team/components/settings/cicd/team-variable-table.vue';
import CompanyVariableTable from '@shared/modules/company/components/settings/cicd/company-variable-table';
import GfEntityMembersWrapper from '@/shared-modules/shared-components/wrappers/main/settings/GfEntityMembersWrapper';
import GfVerificationIcon from '@shared/shared-components/shared/GfVerificationIcon';

import VueRouter from 'vue-router';
import * as Moment from 'moment';
import JSHelperPlugin from './helpers';
import { routes as baseRoutes } from './router';
import store from './store/cloudweb';
import interceptors from './interceptors';
import { i18n, pluralize } from '@/i18n';

/* GENERATED MODULES IMPORT */
import MergeRequestRoutes from './shared-modules/modules/merge-request/merge-request.routing';
import ProjectIssuesRoutes from './shared-modules/modules/project-issue/project-issue.routing';
import NotificationsRoutes from './shared-modules/modules/notifications/notifications.routing';
import CiCdRoutes from './shared-modules/modules/ci-cd/ci-cd.routing';
import ProjectCreateRoutes from './shared-modules/modules/project-create/project.create.routing';
import EntityCreateRoutes from './shared-modules/modules/entity-create/entity.create.routing';
import PrjectFilesRoutes from './shared-modules/modules/project-files/project-files.routing';
import CommitRouter from './shared-modules/modules/commit/commit.routing';
import adminCompanyRouting from './shared-modules/modules/admin/company/admin.company.routing';
import InsightsRoutes from './shared-modules/modules/insights/insights.routing';
import CustomRolesRouter from './shared-modules/modules/custom-roles/custom-roles.routing';
import companyFilter from '@/shared-modules/modules/company/company.routing';
import AdminProjectCreateRoutes from '@/shared-modules/modules/admin/admin-project-create/admin.project.create.routing';
import AdminEntityCreateRoutes from '@/shared-modules/modules/admin/admin-entity-create/admin.entity.create.routing';
import ProjectsRouting from '@/shared-modules/modules/projects/projects.routing';
import StarredRouting from '@/shared-modules/modules/starred/starred.routing';
import ProfileRouting from '@/shared-modules/modules/profile/profile.routing';
import SearchRouting from '@shared/modules/search/search.routing';
import EnvironmentRoutes from '@/shared-modules/modules/environment/environment.routing';

Vue.use(JSHelperPlugin);
interceptors();
Moment.locale('ru');
window.Vue = Vue;
Vue.prototype.$moment = Moment;
Vue.prototype.$store = store;
Vue.prototype.$pluralize = pluralize;

if (process.env.NODE_ENV !== 'development') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
} else {
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = false;
}

Vue.config.productionTip = false;
Vue.use(VueRouter);

let routes = baseRoutes;
routes = routes.concat(MergeRequestRoutes);
routes = routes.concat(ProjectIssuesRoutes);
routes = routes.concat(NotificationsRoutes);
routes = routes.concat(CiCdRoutes);
routes = routes.concat(ProjectCreateRoutes);
routes = routes.concat(EntityCreateRoutes);
routes = routes.concat(PrjectFilesRoutes);
routes = routes.concat(CommitRouter);
routes = routes.concat(InsightsRoutes);
routes = routes.concat(CustomRolesRouter);
routes = routes.concat(adminCompanyRouting);
routes = routes.concat(AdminProjectCreateRoutes);
routes = routes.concat(AdminEntityCreateRoutes);
routes = routes.concat(companyFilter);
routes = routes.concat(ProjectsRouting);
routes = routes.concat(StarredRouting);
routes = routes.concat(ProfileRouting);
routes = routes.concat(SearchRouting);
routes = routes.concat(EnvironmentRoutes);

/* GENERATED MODULES IMPORT */
try {
  // eslint-disable-next-line global-require
  const approverModuleRoutes = require('./shared-modules/modules/merge-request-approver/merge-request-approver.routing');
  routes = routes.concat(approverModuleRoutes.default);
} catch (e) {
  // eslint-disable-next-line global-require
  const approverModulePlaceholderRoutes = require('./shared-modules/modules/merge-request-approver-placeholder/merge-request-approver-placeholder.routing');
  routes = routes.concat(approverModulePlaceholderRoutes.default);
}

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.noScrollTop) return;
    if (savedPosition) {
      setTimeout(() => {
        window.scrollTo({
          top: savedPosition.y
          // behavior: 'smooth'
        });
        const linkPath = document.querySelector(`a[href="${from.path}"]`);
        if (!linkPath) return;
        const parent = linkPath.closest('tr');
        if (!parent) return;
        parent.classList.add('tr-selection');
      }, 100);
    } else {
      window.scrollTo({
        top: 0
        // behavior: 'smooth'
      });
    }
  }
});

// GLOBAL COMPONENTS
Vue.component('ProjectBasicSettingsForm', ProjectBasicSettingsForm);
Vue.component('PopupWrapper', PopupWrapper);
Vue.component('ProjectBranchSelector', ProjectBranchSelector);
Vue.component('PreMergeRequestForm', PreMergeRequestForm);
Vue.component('CommitDiffList', CommitDiffList);
Vue.component('PyPiForm', PyPiForm);
Vue.component('RepositoryFilesList', RepositoryFilesList);
Vue.component('CustomSelectorDotOption', CustomSelectorDotOption);
Vue.component('ForkInformation', forkInformation);
Vue.component('ReportForm', reportForm);
Vue.component('ProjectLanguageSelector', ProjectLanguageSelector);
Vue.component('GfQrCodeGenerator', GfQrCodeGenerator);
Vue.component('GfCustomClipboard', GfCustomClipboard);
Vue.component('ProjectMemberSelector', ProjectMemberSelector);
Vue.component('ProjectOwnerSelector', ProjectOwnerSelector);
Vue.component('ProjectTagSelector', ProjectTagSelector);
Vue.component('ProjectTopicSelector', ProjectTopicSelector);
Vue.component('GfDropdown', GfDropdown);
Vue.component('GfCustomTabs', GfCustomTabs);
Vue.component('GfCustomModalWindow', GfCustomModalWindow);
Vue.component('GfCustomTooltip', GfCustomTooltip);
Vue.component('GfUserAvatarCropper', GfUserAvatarCropper);
Vue.component('GfUserCoverCropper', GfUserCoverCropper);
Vue.component('GfProjectTabsEdit', GfCloudwebProjectTabsEdit);
Vue.component('GfCustomCollapse', GfCustomCollapse);
Vue.component('GfCustomAlert', GfCustomAlert);
Vue.component('GfCustomTextEditor', GfCustomTextEditor);
Vue.component('GfCopyCommitHash', GfCopyCommitHash);
Vue.component('GfCustomMultiFileUploader', GfCustomMultiFileUploader);
Vue.component('tagReleaseSortTypeSelector', tagReleaseSortTypeSelector);
Vue.component('tagReleaseSortDirectionSelector', tagReleaseSortDirectionSelector);
Vue.component('GfCustomFileUploader', GfCustomFileUploader);
Vue.component('GfTeamAvatarCropper', GfTeamAvatarCropper);
Vue.component('GfCompanyAvatarCropper', GfCompanyAvatarCropper);
Vue.component('GfRegistryCategorySelector', GfRegistryCategorySelector);
Vue.component('GfAddFilesDropdown', GfAddFilesDropdown);
Vue.component('GfCompanyCoverCropper', GfCompanyCoverCropper);
Vue.component('GfCloneProjectDropdown', GfCloneProjectDropdown);
Vue.component('ProjectCiCdSettingsForm', ProjectCiCdSettingsForm);
Vue.component('GfCustomInputNumber', GfCustomInputNumber);
Vue.component('RegistryKeySelector', RegistryKeySelector);
Vue.component('GfDropdownCiCd', GfDropdownCiCd);
Vue.component('ProjectFilterForm', ProjectFilterForm);
Vue.component('ProjectSettingsWebhookUrl', ProjectSettingsWebhookUrl);
Vue.component('GfProjectCardStatic', GfProjectCardStatic);
Vue.component('GfSettingsProjectCardStatic', GfSettingsProjectCardStatic);
Vue.component('GfListGridControllerStatic', GfListGridControllerStatic);
Vue.component('TeamVariableTable', TeamVariableTable);
Vue.component('CompanyVariableTable', CompanyVariableTable);
Vue.component('GfCompanyCardStatic', GfCompanyCardStatic);
Vue.component('GfUserCardStatic', GfUserCardStatic);
Vue.component('ProfileLayout', ProfileLayout);
Vue.component('GfButtonSubscribeUser', GfButtonSubscribeUser);
Vue.component('GfButtonShare', GfButtonShare);
Vue.component('GfButton', GfButton);
Vue.component('GfLinkButton', GfLinkButton);
Vue.component('GfUserFollowersCounter', GfUserFollowersCounter);
Vue.component('GfTeamCardStatic', GfTeamCardStatic);
Vue.component('GfButtonTeamSubscribe', GfButtonTeamSubscribe);
Vue.component('GfButtonCompanySubscribe', GfButtonCompanySubscribe);
Vue.component('GfButtonProjectSubscribe', GfButtonProjectSubscribe);
Vue.component('GfPackageCardStatic', GfPackageCardStatic);
Vue.component('GfEntityMembersWrapper', GfEntityMembersWrapper);
Vue.component('GfVerificationIcon', GfVerificationIcon);

// FILTERS
Vue.filter('cutCommitHash', (val) => {
  return val.substr(0, 7);
});

// Active modules
store.state.referenceStore.mrApproversEnabled = true;

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  mounted() {
    this.initThemeSwitcher();
    this.initServiceWorker();
    this.updateTextCookies();
  },
  methods: {
    initThemeSwitcher() {
      const switcher = document.querySelector('.supple-scheme-switcher');
      const switcherRadios = document.querySelectorAll('.supple-scheme-switcher input');
      if (!switcher || !switcherRadios) return;

      const setupSwitcher = () => {
        const savedScheme = getSavedScheme();
        let currentRadio;
        if (savedScheme !== null) {
          currentRadio = document.querySelector(
            `.supple-scheme-switcher__radio[value=${savedScheme}]`
          );
          currentRadio.checked = true;
        }

        [...switcherRadios].forEach((radio) => {
          radio.addEventListener('change', (event) => {
            setScheme(event.target.value);
          });
          radio.addEventListener('click', () => {
            showNotice();
          });
        });

        setupScheme();
      };
      const setupScheme = () => {
        const savedScheme = getSavedScheme();
        if (savedScheme === null) return;
        setScheme(savedScheme);
      };

      function getCookie(name) {
        function escape(s) {
          return s.replace(/([.*+?^$(){}|[\]/\\])/g, '\\$1');
        }
        const match = document.cookie.match(RegExp(`(?:^|;\\s*)${escape(name)}=([^;]*)`));
        return match ? match[1] : null;
      }

      const setScheme = (scheme) => {
        this.$store.dispatch('setColorScheme', scheme);
        saveScheme(scheme);
        setBodyClass(scheme);
      };

      const getSavedScheme = () => getCookie('colorScheme');
      const saveScheme = (scheme) => {
        document.cookie = `colorScheme=${scheme}; expires=${new Date(
          new Date().getTime() + 1000 * 60 * 60 * 24 * 365
        ).toGMTString()}; path=/`;
      };
      const setBodyClass = (scheme) => {
        document.body.classList.remove('--theme-light', '--theme-auto', '--theme-dark');
        document.body.classList.add(`--theme-${scheme}`);
      };
      const showNotice = () => {
        switcher.classList.add('--notice');
        setTimeout(() => {
          switcher.classList.remove('--notice');
        }, 3000);
      };

      setupSwitcher();
    },
    initServiceWorker() {
      window.onappinstalled = () => {
        if ('serviceWorker' in navigator) {
          window.addEventListener('load', async () => {
            try {
              const reg = await navigator.serviceWorker.register('/service-worker.js');
              console.log('Воркер успешно зарегистрирован! 😎', reg);
            } catch (err) {
              console.log('😥 Ошибка регистрации воркера: ', err);
            }
          });
        }
      };

      // CI/CD Worker
      // if ('serviceWorker' in navigator) {
      //   window.addEventListener('DOMContentLoaded', async () => {
      //     try {
      //       const reg = await navigator.serviceWorker.register(
      //         '/service-worker.js' , {scope: '/'}
      //         // '/static/js/service-workers/ci-cd-service-worker.js'
      //       );
      //       console.log('Watcher scope: ' + reg.scope);
      //       console.log('Воркер успешно зарегистрирован! 😎', reg);
      //     } catch (err) {
      //       console.log('😥 Ошибка регистрации воркера: ', err);
      //     }
      //   });
      // }
    },
    initAlertCoockies(message, link) {
      const buttonText = 'Принять';

      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

      if (getCookie('cookiesAccepted') === 'true') {
        return;
      }

      const html = `
      <div class="cookies">
        <div class="cookies-alert">
          <div class="cookies-alert-layout">
            <p class="cookies-text m-0">
              ${message}
              <a class="cookies-link" target="_blank" href="https://gitflic.ru/docs/cookie-policy">
                ${link}
              </a> 
            </p>
            <button type="button" class="cookies-text cookiesBtn btn">
              ${buttonText}
            </button>
          </div>
        </div>
      </div>
      `;
      document.body.insertAdjacentHTML('afterbegin', html);
      const cookiesBanner = document.querySelector('.cookies');
      const cookiesBtn = document.querySelector('.cookiesBtn');
      window.onload = function () {
        cookiesBanner.classList.add('show');
      };

      cookiesBtn.addEventListener('click', () => {
        document.cookie = 'cookiesAccepted=true; path=/; max-age=' + 60 * 60 * 24 * 365;
        cookiesBanner.classList.remove('show');
      });
    },
    updateTextCookies() {
      const width = window.innerWidth;
      let message;
      let link;

      if (width > 1000) {
        message =
          'Мы используем файлы cookie, чтобы обеспечивать правильную работу веб-сайта. Продолжая пользоваться данным сайтом, вы подтверждаете свое согласие на использование файлов cookie в соответствии ';
        link = 'с политикой обработки файлов cookie.';
      } else {
        message =
          'Мы используем файлы cookie, чтобы обеспечивать правильную работу нашего веб-сайта.';
        link = 'Политика обработки файлов cookie.';
      }

      this.initAlertCoockies(message, link);
    }
  },
  router,
  i18n,
  store
  // render: (h) => h(App),
});
